import { Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider } from '@orisini/ui/context/AuthContext'
import AppShell from './components/layout/AppShell'
import ProtectedRoute from './components/layout/ProtectedRoute'
import AccountsPage from './features/accounts/pages/AccountsPage'
import AgentPage from './features/agent/pages/AgentPage'
import BillingPage from './features/billing/pages/BillingPage'
import BoardsPage from './features/boards/pages/BoardsPage'
import CalendarPage from './features/calendar/pages/CalendarPage'
import ExtensionPage from './features/extension/pages/ExtensionPage'
import HistoryPage from './features/history/pages/HistoryPage'
import DashboardPage from './features/dashboard/pages/DashboardPage'
import HealthPage from './features/dev/pages/HealthPage'
import BulkPage from './features/pins/pages/BulkPage'
import PinEditorPage from './features/pins/pages/PinEditorPage'
import PinsPage from './features/pins/pages/PinsPage'
import SettingsPage from './features/settings/pages/SettingsPage'
import SlotsPage from './features/slots/pages/SlotsPage'

/**
 * Router Pinboss.
 *
 * Tidak ada lagi route /login, /register, maupun /admin untuk user: semuanya
 * milik orisini.com. Pinboss hanya berisi halaman yang benar-benar tentang
 * Pinterest, plus admin operasional yang digerbangi klaim role.
 *
 * Pengecualiannya /billing: halamannya ADA di sini supaya user bisa berlangganan
 * Pinboss tanpa berpindah domain, tapi isinya hanya panel bersama dari
 * @orisini/ui yang memanggil `/api/billing/*` — dan Worker Pinboss meneruskan
 * semuanya ke orisini. Order, uang, dan verifikasinya tetap milik orisini.
 *
 * `idOrigin` memberi tahu AuthContext ke mana harus mengarahkan pengunjung yang
 * kehabisan sesi. Ia dibaca dari variabel build supaya development (lvh.me)
 * dan produksi tidak perlu kode berbeda.
 */
const ID_ORIGIN = import.meta.env.VITE_ID_ORIGIN ?? 'https://orisini.com'

export default function App() {
  return (
    <AuthProvider idOrigin={ID_ORIGIN}>
      <Routes>
        <Route path="/_health" element={<HealthPage />} />

        <Route
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="calendar" element={<CalendarPage />} />
          {/* Antrean sekarang jadi tab di halaman Pin; /queue dipertahankan
              supaya bookmark & tautan lama tidak mati. */}
          <Route path="queue" element={<Navigate to="/pins" replace />} />
          <Route path="pins" element={<PinsPage />} />
          <Route path="pins/bulk" element={<BulkPage />} />
          <Route path="boards" element={<BoardsPage />} />
          <Route path="history" element={<HistoryPage />} />
          <Route path="pins/:id" element={<PinEditorPage />} />
          <Route path="slots" element={<SlotsPage />} />
          <Route path="accounts" element={<AccountsPage />} />
          <Route path="agent" element={<AgentPage />} />
          <Route path="extension" element={<ExtensionPage />} />
          {/* Alamat lama sebelum antarmukanya pindah ke bahasa Inggris. */}
          <Route path="ekstensi" element={<Navigate to="/extension" replace />} />
          <Route path="billing" element={<BillingPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="*" element={<TidakDitemukan />} />
        </Route>
      </Routes>
    </AuthProvider>
  )
}

function TidakDitemukan() {
  return (
    <div className="space-y-2">
      <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
      <p className="text-sm text-muted-foreground">Check the address again.</p>
    </div>
  )
}
